import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/permissionUtils';

/**
 * ProtectedRoute component that checks both authentication and permissions
 * @param {React.Component} children - The component to render if user has permission
 * @param {string|string[]} permissions - Required permission(s) for the route
 * @param {string} redirectTo - Path to redirect to if user doesn't have permission (default: '/')
 */
const ProtectedRoute = ({ children, permissions, redirectTo = '/' }) => {
    const { isAuthenticated } = useSelector((state) => state.auth);
    const userPermissions = useSelector((state) => state.splash?.data?.permissions || []);

    // Check authentication first
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // If no permissions required, allow access
    if (!permissions || (Array.isArray(permissions) && permissions.length === 0)) {
        return children;
    }

    // Check if user has required permissions
    if (!hasPermission(permissions, userPermissions)) {
        // User doesn't have required permissions, redirect
        return <Navigate to={redirectTo} replace />;
    }

    // User has required permissions, render the component
    return children;
};

export default ProtectedRoute;

